import { shipmentHost, toHostedShipmentUrl } from './admin';

// SaaS entitlements API (api-shipments). Admin endpoints power the customer-
// manager Plan & Features selector; /catalog is the shared feature source.
const base = shipmentHost + '/entitlements';
const url = path => toHostedShipmentUrl(base + path);

export const entitlementsMine = url('');
export const entitlementsCatalog = url('/catalog');
export const entitlementsMetrics = url('/metrics');
export const entitlementsSubscribe = url('/subscribe');
export const entitlementsCancel = url('/cancel');
export const entitlementsAdmin = storeId => url('/admin/' + encodeURIComponent(storeId));
